import newsletterBanner from "@assets/images/newsletter.png";
import SideBlockAds from "@components/Blocks/Container/SideBlockAds";
import SignupForm from "@components/Blocks/NewsLetterSignupForm/NewsLetterSignupForm";
import { getGTMData, getMetaData } from "@helper/getMetaData";
import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import BHBasePage, { BHBasePageProps } from "@src/app/routes/BHBasePage";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";

import styles from "./Newsletter.module.css";

export function meta() {
  const uniqueSectionName = "eNewsLetter";
  const metaTags: MetaTagsProps = {
    title: "Langgani E-Newsletter - BeritaHarian.sg",
    slug: uniqueSectionName,
    description:
      "Langgani ringkasan percuma Berita Harian - Langsung ke emel anda.",
  };
  return [getMetaData(metaTags)];
}

export default function NewsletterPage() {
  const sectionName = "eNewsLetter";
  const newsletterPageProps: BHBasePageProps = {
    uniqueSectionName: sectionName,
    pageAdTargetValue: PageAdTargetingTypeEnum.LISTING,
  };

  return (
    <BHBasePage {...newsletterPageProps}>
      <div className="max-w-screen-xl m-auto flex flex-col lg:flex-row">
        <div className="flex lg:px-sm flex-col w-12/12 lg:w-8/12 w-full">
          <span className="text-brand-primary text-lg font-bold">
            Langgani E-Newsletter
          </span>
          <div className="w-full pt-sm">
            <div className={styles.NewsletterContainer}>
              <img
                className={styles.imgFluid}
                src={newsletterBanner}
                alt="newsletter"
              />
              <h3 className="text-base lg:text-2md font-regular text-text-body leading-[160%] mb-4 lg:mb-6">
                Langgani ringkasan percuma Berita Harian - Langsung ke emel
                anda.{" "}
              </h3>
              <SignupForm />
            </div>
          </div>
        </div>
        <SideBlockAds
          pageAdTargetingProps={PageAdTargetingTypeEnum.LISTING}
          adsOnly={true}
          className="flex-1"
        />
      </div>
    </BHBasePage>
  );
}

export function loader(): Promise<TRouteWithRedirect<object | null, string>> {
  const gaData: GADataProps = {
    level2: "miscellaneous",
    title: "E-Newsletter Signup",
    section: "miscellaneous",
    contentcat: "1",
    contenttype: "listing",
  };

  return Promise.resolve({
    type: ResponseType.SUCCESS,
    statusCode: 200,
    payload: null,
    cacheControlMaxAge: 300, // 5 minutes
    regenerateInterval: 172800, // 2 days
    gtm: getGTMData(gaData),
  });
}
